import styled from "styled-components";
import { tmTableHeaderAlignmentStyles } from "../sharedTable.styles";

export const NestedTableWrapperStyled = styled.div`
  padding: 12px 20px;
  background: ${(p) => p.theme?.colors?.light ?? "#F7F7F7"};

  .nested-title {
    font-size: 12.5px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  /* Every row here has an onRow.onClick (expand-to-skill-gap) — the browser
     default cursor doesn't reflect that, so make it explicit. */
  .ant-table-tbody > tr {
    cursor: pointer;
  }

  /* Same filter/sort-icon-next-to-label + opt-in header-centering fix as
     sharedTable.styles.js's ClickableTableWrapperStyled — this wrapper is a
     plain div, not that shared one, so it can't extend it, but the rules
     themselves are identical and shared from there. */
  ${tmTableHeaderAlignmentStyles}
`;
